import api from "../lib/api";
import { getRefresh, saveTokens, saveUser, setTokensFromResponse } from "../lib/tokenStorage";

function getCSRFCookie(name = "csrftoken") {
    const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return m ? decodeURIComponent(m[1]) : undefined;
}

type LoginResponse = {
    message?: string;
    user?: any;
    access?: string;
    refresh?: string;
    token?: string;
    access_token?: string;
    refresh_token?: string;
};

const LOGIN_HEADER = "token";
const LOGIN_SCHEME = "Bearer";

export async function loginWithFirebaseToken(idToken: string) {
    const csrf = getCSRFCookie();
    const { data } = await api.post<LoginResponse>(
        "/users/login/",
        { token: idToken },
        { headers: csrf ? { "X-CSRFTOKEN": csrf, Authorization: "" } : { Authorization: "" } }
    );

    const ok = setTokensFromResponse(data);
    if (!ok) throw new Error("Login response missing tokens");
    saveUser(data.user ?? null);
    return data;
}

export async function logoutBackend(refreshFromCaller?: string) {
    const refresh = refreshFromCaller ?? getRefresh();
    if (!refresh) return;
    try {
        await api.post("/users/logout/", { refresh });
    } catch {
    }
}